<template>
  <div class="cart__empty">
    <h1>Cart is empty</h1>
    <router-link
      to="/products"
      class="button more-info-button">Add Products</router-link>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.cart {
  @include e("empty") {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding: 65px 8.5%;
  }
}
</style>
